import createHowItWorksCarousel from './components/hiw-carousel';

document.addEventListener('DOMContentLoaded', () => {
    createHowItWorksCarousel(document.querySelector('[data-hiw]'));
});



// WEBPACK FOOTER //
// ./js/marketing/projectsHome.js